/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 10.1.2
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The level of precision for the geometry.
 * @export
 */
export const Precision = {
  Point: "point",
  Centroid: "centroid",
} as const;
export type Precision = (typeof Precision)[keyof typeof Precision];

export function instanceOfPrecision(value: any): boolean {
  for (const key in Precision) {
    if (Object.prototype.hasOwnProperty.call(Precision, key)) {
      if (Precision[key as keyof typeof Precision] === value) {
        return true;
      }
    }
  }
  return false;
}

export function PrecisionFromJSON(json: any): Precision {
  return PrecisionFromJSONTyped(json, false);
}

export function PrecisionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Precision {
  return json as Precision;
}

export function PrecisionToJSON(value?: Precision | null): any {
  return value as any;
}

export function PrecisionToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): Precision {
  return value as Precision;
}
